<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-07-22 16:14:31
 * @LastEditTime: 2019-08-14 10:10:22
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div id="app">
    <keep-alive>
      <router-view v-wechat-title="$route.name" />
    </keep-alive>
    <div id="loadingToast"
         style="display:none;">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-loading weui-icon_toast"></i>
        <p class="weui-toast__content">数据加载中</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
body {
  background-color: #f0f0f0;
}
.scroll_inner {
  min-height: calc(100% + 1px);
}
.tab_bar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100px;
  background-color: #fff;
  border-top: 1px solid #f0f0f0; /* no */
}

.tab_bar .tab_bar_item {
  display: block;
  width: 50%;
  float: left;
  height: 100px;
  position: relative;
}

.tab_bar_item img {
  position: absolute;
  width: 50px;
  height: 50px;
  left: calc(50% - 25px);
  top: 10px;
}

.tab_bar_item span {
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center;
  top: 65px;
  font-size: 22px;
  color: #333333;
}

.tab_bar_item .active {
  color: #fe5f5e;
}

.navi_bar {
  display: flex;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 500;
  width: 100%;
  height: 100px;
  flex-direction: row;
  text-align: center;
  color: #333333;
  font-size: 32px;
  box-sizing: border-box;
  background-color: #fefcf2;
  border-bottom: 1px solid #fbf2dc; /* no */
}

.navi_bar .navi_bar_item {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7c4d1f;
}

.navi_bar_item .active {
  transition: all 0.4s;
  border-bottom: 4px solid #ff000c; /* no */
  color: #ff000c;
  padding: 24px 0;
}
.page_bd_spacing {
  padding: 0 15px;
}
.weui-cell:before {
  left: 0;
}
.toast_text {
  .weui-toast {
    width: 500px;
    min-height: auto;
    padding: 15px;
    margin-left: -250px;
    top: auto;
    bottom: 100px;
  }
  .weui-toast-center {
    max-width: 500px;
    min-height: auto;
    padding: 15px;
    position:fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  .weui-icon_toast {
    display: none;
  }
  .weui-toast__content {
    line-height: 40px;
    margin: 0;
  }
}
.weui-toast-center{

  .weui-toast {
    max-width: 500px;
    min-height: auto;
    padding: 15px;
    position:fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    margin: 0;
    min-width: 250px;
  }
  .weui-icon_toast {
    display: none;
  }
  .weui-toast__content {
    line-height: 40px;
    margin: 0;
  }
}
.toast_circle .weui-icon-success-no-circle:before {
  content: "\EA01";
}
.toast_download .weui-icon-success-no-circle:before {
  content: "\EA02";
}
.toast_info .weui-icon-success-no-circle:before {
  content: "\EA03";
}
.toast_safe-success .weui-icon-success-no-circle:before {
  content: "\EA04";
}
.toast_safe-warn .weui-icon-success-no-circle:before {
  content: "\EA05";
}
.toast_success .weui-icon-success-no-circle:before {
  content: "\EA06";
}
.toast_success-circle .weui-icon-success-no-circle:before {
  content: "\EA07";
}
.toast_success-no-circle .weui-icon-success-no-circle:before {
  content: "\EA08";
}
.toast_waiting .weui-icon-success-no-circle:before {
  content: "\EA09";
}
.toast_waiting-circle .weui-icon-success-no-circle:before {
  content: "\EA0A";
}
.toast_info-circle .weui-icon-success-no-circle:before {
  content: "\EA0C";
}
.toast_cancel .weui-icon-success-no-circle:before {
  content: "\EA0D";
}
.toast_search .weui-icon-success-no-circle:before {
  content: "\EA0E";
}
.toast_clear .weui-icon-success-no-circle:before {
  content: "\EA0F";
}
.toast_back .weui-icon-success-no-circle:before {
  content: "\EA10";
}
.toast_delete .weui-icon-success-no-circle:before {
  content: "\EA11";
}
#clip_button {
  position: absolute;
  right: 10%;
  bottom: 20px;
  width: 160px;
  height: 40px;
  border:none;
  border-radius: 2px;
  background: #000;
  color: #fff;
}
#cancel_clip{
  position: absolute;
  left: 10%;
  bottom: 20px;
  width: 80px;
  height: 40px;
  border:none;
  border-radius: 2px;
  color: #fff;
  background:#000;
}
#clip_container.container {
  z-index: 99;
  position: fixed;
  padding-top: 60px;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background:rgba(0,0,0,1);
}
#clip_container.container > div{
  position: absolute;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%,-50%);
  transform: translate(-50%,-50%);
}
#clip_image {
  max-width: 100%;
}

.cropper-container {
  font-size: 0;
  line-height: 0;
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  direction: ltr;
  -ms-touch-action: none;
  touch-action: none
}
.crop_loading , .crop_success {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
}
.crop_loading .crop_content{
  position: absolute;
  top: 50% ;
  left: 50%;
  text-align: center;
  background: #000;
  opacity: 0.9;
  height: 100px;
  width: 100px;
  vertical-align: middle;
  color: #fff;
  padding-top: 20px;
  font-size: 16px;
  -webkit-border-radius:3px;
  border-radius:3px;
  -webkit-transform: translate(-50%,-50%);
  transform: translate(-50%,-50%);
}
.crop_loading .crop_content img{
  margin-top: 15px;
  margin-bottom: 10px;
}
.crop_success .crop_success_text{
  position: absolute;
  top: 50% ;
  left: 50%;
  text-align: center;
  background: #000;
  opacity: 0.9;
  width: 120px;
  height: 30px;
  color: #fff;
  line-height: 30px;
  font-size: 16px;
  -webkit-border-radius:3px;
  border-radius:3px;
  -webkit-transform: translate(-50%,-50%);
  transform: translate(-50%,-50%);
}
.cropper-container img {
  /* Avoid margin top issue (Occur only when margin-top <= -height) */
  display: block;
  min-width: 0 !important;
  max-width: none !important;
  min-height: 0 !important;
  max-height: none !important;
  width: 100%;
  height: 100%;
  image-orientation: 0deg
}

.cropper-wrap-box,
.cropper-canvas,
.cropper-drag-box,
.cropper-crop-box,
.cropper-modal {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.cropper-wrap-box {
  overflow: hidden;
}

.cropper-drag-box {
  opacity: 0;
  background-color: #fff;
}

.cropper-modal {
  opacity: .5;
  background-color: #000;
}

.cropper-view-box {
  display: block;
  overflow: hidden;

  width: 100%;
  height: 100%;

  outline: 1px solid #39f;
  outline-color: rgba(51, 153, 255, 0.75);
}

.cropper-dashed {
  position: absolute;

  display: block;

  opacity: .5;
  border: 0 dashed #eee
}

.cropper-dashed.dashed-h {
  top: 33.33333%;
  left: 0;
  width: 100%;
  height: 33.33333%;
  border-top-width: 1px;
  border-bottom-width: 1px
}

.cropper-dashed.dashed-v {
  top: 0;
  left: 33.33333%;
  width: 33.33333%;
  height: 100%;
  border-right-width: 1px;
  border-left-width: 1px
}

.cropper-center {
  position: absolute;
  top: 50%;
  left: 50%;

  display: block;

  width: 0;
  height: 0;

  opacity: .75
}

.cropper-center:before,
.cropper-center:after {
  position: absolute;
  display: block;
  content: ' ';
  background-color: #eee
}

.cropper-center:before {
  top: 0;
  left: -3px;
  width: 7px;
  height: 1px
}

.cropper-center:after {
  top: -3px;
  left: 0;
  width: 1px;
  height: 7px
}

.cropper-face,
.cropper-line,
.cropper-point {
  position: absolute;

  display: block;

  width: 100%;
  height: 100%;

  opacity: .1;
}

.cropper-face {
  top: 0;
  left: 0;

  background-color: #fff;
}

.cropper-line {
  background-color: #39f
}

.cropper-line.line-e {
  top: 0;
  right: -3px;
  width: 5px;
  cursor: e-resize
}

.cropper-line.line-n {
  top: -3px;
  left: 0;
  height: 5px;
  cursor: n-resize
}

.cropper-line.line-w {
  top: 0;
  left: -3px;
  width: 5px;
  cursor: w-resize
}

.cropper-line.line-s {
  bottom: -3px;
  left: 0;
  height: 5px;
  cursor: s-resize
}

.cropper-point {
  width: 5px;
  height: 5px;

  opacity: .75;
  background-color: #39f
}

.cropper-point.point-e {
  top: 50%;
  right: -3px;
  margin-top: -3px;
  cursor: e-resize
}

.cropper-point.point-n {
  top: -3px;
  left: 50%;
  margin-left: -3px;
  cursor: n-resize
}

.cropper-point.point-w {
  top: 50%;
  left: -3px;
  margin-top: -3px;
  cursor: w-resize
}

.cropper-point.point-s {
  bottom: -3px;
  left: 50%;
  margin-left: -3px;
  cursor: s-resize
}

.cropper-point.point-ne {
  top: -3px;
  right: -3px;
  cursor: ne-resize
}

.cropper-point.point-nw {
  top: -3px;
  left: -3px;
  cursor: nw-resize
}

.cropper-point.point-sw {
  bottom: -3px;
  left: -3px;
  cursor: sw-resize
}

.cropper-point.point-se {
  right: -3px;
  bottom: -3px;
  width: 20px;
  height: 20px;
  cursor: se-resize;
  opacity: 1
}

@media (min-width: 768px) {

  .cropper-point.point-se {
    width: 15px;
    height: 15px
  }
}

@media (min-width: 992px) {

  .cropper-point.point-se {
    width: 10px;
    height: 10px
  }
}

@media (min-width: 1200px) {

  .cropper-point.point-se {
    width: 5px;
    height: 5px;
    opacity: .75
  }
}

.cropper-point.point-se:before {
  position: absolute;
  right: -50%;
  bottom: -50%;
  display: block;
  width: 200%;
  height: 200%;
  content: ' ';
  opacity: 0;
  background-color: #39f
}

.cropper-invisible {
  opacity: 0;
}

.cropper-bg {
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC');
}

.cropper-hide {
  position: absolute;

  display: block;

  width: 0;
  height: 0;
}

.cropper-hidden {
  display: none !important;
}

.cropper-move {
  cursor: move;
}

.cropper-crop {
  cursor: crosshair;
}

.cropper-disabled .cropper-drag-box,
.cropper-disabled .cropper-face,
.cropper-disabled .cropper-line,
.cropper-disabled .cropper-point {
  cursor: not-allowed;
}
.html_banner {
  img{
    display: block;
  }
}
*{
  -webkit-tap-highlight-color:rgba(0,0,0,0);
}
body{
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue